'use strict';
var parent = require('../../stable/instance/map');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/instance/map.js
// module id = 534
// module chunks = 13